import { isDevMode } from '@angular/core';
import { ActionReducer, ActionReducerMap, MetaReducer } from '@ngrx/store';
import { routerReducer, RouterReducerState } from '@ngrx/router-store';
import { featuresReducer } from './reducers/features.reducer';
import { cultureReducer, routerHistoryReducer, sharedReducer } from './reducers/shared.reducer';
import { staticReducer } from './reducers/static.reducer';
import { resetAppStateAction } from './actions/shared.action';
import { festivalReducer } from './reducers/festival.reducer';


export interface AppState {
  features: any;
  shared: any;
  culture: any;
  static: any;
  festival: any;
  routerHistory: string[];
  // Other feature states will be registered lazily
}

export const reducers: ActionReducerMap<AppState> = {
  features: featuresReducer,
  shared: sharedReducer,
  culture: cultureReducer,
  static: staticReducer,
  festival: festivalReducer,
  routerHistory: routerHistoryReducer
};

export function clearStateMetaReducer(
  reducer: ActionReducer<AppState>
): ActionReducer<AppState> {
  return function (state, action) {
    if (action.type === resetAppStateAction.type) {
      // Important: Pass action to get proper initial state
      const newState = reducer(undefined, action);
      return newState;
    }
    return reducer(state, action);
  };
}

export const metaReducers: MetaReducer<AppState>[] = [clearStateMetaReducer];
